import React, { Fragment } from "react"
import { Link } from "react-router-dom"

const featureContentTwo = [
    {
        icon: "icon-9a",
        title: "Crear Cuenta",
        desc: "Proporcionamos acceso interactivo a materiales de clase mundial para catalizadores.",
        dataAos: "fade-up",
        dataDelay: ""
    },
    {
        icon: "icon-10a",
        title: "Leer Reglas",
        desc: "Proporcionamos acceso interactivo a materiales de clase mundial para catalizadores.",
        dataAos: "fade-up",
        dataDelay: "100"
    },
    {
        icon: "icon-11a",
        title: "Consultar Problema",
        desc: "Proporcionamos acceso interactivo a materiales de clase mundial para catalizadores.",
        dataAos: "fade-up",
        dataDelay: "200"
    },
    {
        icon: "icon-12a",
        title: "Obtener Solución",
        desc: "Proporcionamos acceso interactivo a materiales de clase mundial para catalizadores.",
        dataAos: "fade-up",
        dataDelay: "300"
    },
    {
        icon: "icon-10a",
        title: "Bien Documentado",
        desc: "Proporcionamos acceso interactivo a materiales de clase mundial para catalizadores.",
        dataAos: "fade-up",
        dataDelay: "400"
    },
]

const FeatureTwo = () => {
  return (
    <Fragment>
        {featureContentTwo.map((val, i)=>(
            <div key={i} className="col-lg-4 col-md-6" data-aos={val.dataAos} data-aos-delay={val.dataDelay}>
                <div className="feature-style-two mb-45">
                    <div className="icon"><img src={`assets/img/icon/${val.icon}.png`}alt="icon" /></div>
                    <h3>
                        <Link to="faq">{val.title}</Link>
                    </h3>
                    <p>{val.desc}</p>
                </div>
            </div>
        ))}              
    </Fragment>
  )
}

export default FeatureTwo